export function roundToTwoDecimals(nb: number): number {
  return Math.round(nb * 100) / 100;
}
